<form>
  <ng-container *transloco="let t; read: 'ime.common.specs'">
    <div class="modal-header" ngxModalDraggable>
      <h3 class="mr-4">
        {{title}}
      </h3>
      <button type="button" class="btn-close" aria-label="Close" (click)="serializeAndClose()">
      </button>
    </div>
    <div class="modal-body" *ngIf="fileLink">
      <div class="card">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">{{ t('File name')}}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="filename" name="filename" [(ngModel)]="fileLink.FileName">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">{{ t('Description')}}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="description" name="description" [(ngModel)]="fileLink.Description">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">{{t('Path')}}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="path" name="path" [(ngModel)]="fileLink.Path">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">{{t('Preview')}}</label>
            <div class="col-sm-8">
              <a class="btn btn-outline-primary" type="button" [href]="fileLink.Path" target="_blank">{{t('Open')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>
